var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseCard',{attrs:{"title":"Invoice Terms","step-component":"InvoiceTermsStep"}},[_c('v-row',[_c('v-col',[_vm._v(" Receive Invoices Via: "+_vm._s(_vm.text)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }